import { IMarkedListTextBlockSchema } from '../../repositories/countryside-search/entities/marked_list_text_block/MarkedListTextBlockSchema';
import { IApplicationState } from '../../types/store';

export const selectMarkedListItems = (state: IApplicationState): IMarkedListTextBlockSchema[] => {
  return state.seo.markedList?.items || [];
};
